import { WishlistList } from "./components/wishlist";

function Wishlist() {
    return (
        <>
            <WishlistList />
        </>
    );
}

export default Wishlist;